module.exports = __webpack_public_path__ + "img/team3.624ad78d.png";